/*
 * The thread of the Lienzo editor's conversation (the mockup's `.msg-user` and `.msg-ai`): the
 * person's messages are bubbles on the right; the assistant's answers, questions and errors read
 * on the left, unframed, with a state colour only where the kind is a state.
 */
.thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.message {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-inline-size: 100%;
}

.message[data-kind="input"] {
  align-self: flex-end;
  max-inline-size: 88%;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: 10px 10px 4px 10px;
  background: var(--surface-sunken);
}

.message[data-kind="question"] {
  padding-inline-start: var(--space-3);
  border-inline-start: 2px solid var(--info-text);
}

.message[data-kind="error"] {
  padding-inline-start: var(--space-3);
  border-inline-start: 2px solid var(--danger-text);
}

.answerHint {
  margin: var(--space-2) 0 0;
  color: var(--info-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.author {
  color: var(--text-muted);
  font-weight: var(--font-weight-medium);
}

.body {
  margin: 0;
  color: var(--text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.link {
  align-self: flex-start;
  color: var(--action-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.link:focus-visible {
  border-radius: var(--radius-small);
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.editOf {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-style: italic;
}
